/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IHosportsZendeskViewProps } from './hosports-zendesk';

export default (props: IHosportsZendeskViewProps) => {
    return (
        <div>{'Zendesk Widget'}</div>
    );
};
